import moment from "moment";

export const getTodayDateStringForHeader = () => {
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var d = new Date();

  let date = d.getDate();
  let dayName = days[d.getDay()];
  let monthName = monthNames[d.getMonth()];
  let year = d.getFullYear();

  return `${date} ${monthName} ${year} - ${dayName}`;
};

export const createTimeSlots = (param) => {
  if (createStartOfday(param) == createStartOfday(new Date())) {
    let startTimeRoundoff15 = roundToNearest15(new Date());

    let startHour = startTimeRoundoff15.getHours();
    let startMinute = startTimeRoundoff15.getMinutes();
    let obj = {
      startTime: new Date().setHours(startHour, startMinute, 0, 0),
      endTime: new Date().setHours(23, 0, 0, 0),
    };
    let intervals = createTimeIntervals(obj);
    return intervals;
  } else {
    console.log("Its not today");
    let obj = {
      startTime: new Date().setHours(1, 0, 0, 0),
      endTime: new Date().setHours(23, 0, 0, 0),
    };
    let intervals = createTimeIntervals(obj);
    return intervals;
  }
};

let createStartOfday = (date) => new Date(date).setHours(0, 0, 0, 0);

function createTimeIntervals({ startTime, endTime }) {
  const intervals = [];
  // const startTime = new Date();
  // startTime.setHours(9, 0, 0, 0); // Set start time to 9 AM

  // const endTime = new Date();
  // endTime.setHours(18, 0, 0, 0); // Set end time to 6 PM

  let intervalTime = new Date(startTime); // Create a copy of start time to increment

  while (intervalTime <= endTime) {
    intervals.push(moment(new Date(intervalTime)).format("hh:mm A")); // Push a copy of the interval time to array
    intervalTime.setTime(intervalTime.getTime() + 15 * 60 * 1000); // Increment interval time by 15 minutes
  }

  return intervals;
}

function roundToNearest15(date) {
  const currentDate = new Date(date);
  return new Date(
    Math.ceil(currentDate.getTime() / (15 * 60 * 1000)) * (15 * 60 * 1000)
  );
}

export function createBack30DaysWithOneDayGap() {
  const dates = [];
  const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  const today = new Date(); // Today's date
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  for (let i = 30; i >= 0; i--) {
    if (i % 2 == 0) {
      const date = new Date(today.getTime() - i * oneDay);
      const month = months[date.getMonth()];
      const year = date.getFullYear().toString().slice(-2);
      const det = date.getDate();
      const dateString = `${month} ${det}`;
      dates.push(dateString); // Add date string to array
    }
  }
  return dates;
}

export function createBack30DaysWithSevenDayGap() {
  const dates = [];
  const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  const oneWeek = 7 * oneDay; // One week in milliseconds
  const today = new Date(); // Today's date
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  for (let i = 30; i >= 0; i -= 7) {
    const date = new Date(today.getTime() - i * oneDay);
    const month = months[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    const det = date.getDate();
    const dateString = `${month} ${det}`;
    dates.push(dateString); // Add date string to array
  }
  return dates;
}

export function createBack30DaysWithMonthGap() {
  const dates = [];
  const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  const oneWeek = 30 * oneDay; // One week in milliseconds
  const today = new Date(); // Today's date
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  for (let i = 30; i >= 0; i -= 30) {
    const date = new Date(today.getTime() - i * oneDay);
    const month = months[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    const det = date.getDate();
    const dateString = `${month} ${det}`;
    dates.push(dateString); // Add date string to array
  }
  return dates;
}
